import { render } from "./SignaturePad.vue?vue&type=template&id=4ce1c940&scoped=true"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"

import "./SignaturePad.vue?vue&type=style&index=0&id=4ce1c940&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce1c940"]])

export default __exports__